import { MenuItem } from '@src/common/components/Menu';
import { useToast } from '@src/common/hooks/useToast';
import { OrderDeletionModal } from '@src/orders/components/orderActionsMenu/modal/OrderDeletionModal';
import type { OrderListing } from '@src/orders/domain/OrderList';
import { OrderActions } from '@src/orders/domain/OrderList';
import { useRefreshOrders } from '@src/orders/hooks/useRefreshOrders';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  order: OrderListing;
  onDeleteSuccess: () => void;
};
export const DeleteAction = ({ order, onDeleteSuccess }: Props) => {
  const { t } = useTranslation();
  const { refreshOrders } = useRefreshOrders();
  const { showSuccessToast, showErrorToast } = useToast();

  const [openDeletionModal, setOpenDeletionModal] = useState(false);

  const handleDeleteClick = () => {
    setOpenDeletionModal(true);
  };
  return (
    order.canDo(OrderActions.DELETE) && (
      <>
        <MenuItem key={`${order.id}-delete`} onClick={handleDeleteClick}>
          {t('delete')}
        </MenuItem>
        <OrderDeletionModal
          open={openDeletionModal}
          onClose={() => {
            setOpenDeletionModal(false);
          }}
          onSuccess={() => {
            showSuccessToast(t('orderSummary.deleteSuccessful'));
            refreshOrders();

            setOpenDeletionModal(false);
            onDeleteSuccess();
          }}
          onError={() => {
            showErrorToast(t('orderSummary.deleteError'));
          }}
          order={order}
        />
      </>
    )
  );
};
